.viewport {
  position: fixed;
  right: var(--space-5);
  bottom: var(--space-5);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  width: 380px;
  max-width: calc(100vw - var(--space-7));
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--color-surface-raised);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-inline-start: var(--border-width-thick) solid var(--tone-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-medium);
}

.toast[data-state="open"] {
  animation: slide-in var(--duration-normal) var(--easing-decelerate);
}

.toast[data-state="closed"] {
  animation: fade-out var(--duration-fast) var(--easing-accelerate);
}

.toast[data-swipe="move"] {
  transform: translateX(var(--radix-toast-swipe-move-x));
}

.toast[data-swipe="cancel"] {
  transform: translateX(0);
  transition: transform var(--duration-fast) var(--easing-standard);
}

.toast[data-swipe="end"] {
  animation: swipe-out var(--duration-fast) var(--easing-accelerate);
}

.success {
  --tone-border: var(--color-success-emphasis);
  --tone-fg: var(--color-success-fg);
}

.danger {
  --tone-border: var(--color-danger-emphasis);
  --tone-fg: var(--color-danger-fg);
}

.info {
  --tone-border: var(--color-info-emphasis);
  --tone-fg: var(--color-info-fg);
}

.toastGlyph {
  flex: none;
  margin-top: 2px;
  color: var(--tone-fg);
}

.toastBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  flex: 1 1 auto;
  min-width: 0;
}

.toastTitle {
  font-size: var(--text-base);
  line-height: var(--text-base-line);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.toastDescription {
  font-size: var(--text-sm);
  line-height: var(--text-sm-line);
  color: var(--color-text-secondary);
  text-wrap: pretty;
}

/* The one animated entrance in the product, and it is justified: a toast that
 * appears instantly in the corner is routinely missed, because nothing drew
 * the eye to a region that was empty a frame ago. It resolves to nothing under
 * `prefers-reduced-motion`, via the duration tokens. */
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(var(--space-5));
  }
}

@keyframes fade-out {
  to {
    opacity: 0;
  }
}

@keyframes swipe-out {
  from {
    transform: translateX(var(--radix-toast-swipe-end-x));
  }

  to {
    transform: translateX(100%);
  }
}
